import Tabs from './Tabs';
import './Tabs.scss';

export default Tabs;